import { render, staticRenderFns } from "./ModalTempo.vue?vue&type=template&id=532a0f9c&scoped=true"
import script from "./ModalTempo.vue?vue&type=script&lang=js"
export * from "./ModalTempo.vue?vue&type=script&lang=js"
import style0 from "./ModalTempo.vue?vue&type=style&index=0&id=532a0f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a0f9c",
  null
  
)

export default component.exports